// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6472772d","455":"1fe8e257"}[chunkId] + ".chunk.js";
};